module.exports = __webpack_public_path__ + "static/sca_exemptions2-5f10ff56b7486a27c5665cc5fd09983b.png";